import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-portal px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-primary-400 to-accent-600 font-heading text-lg font-black text-foreground-950">
                金
              </span>
              <span className="font-heading text-xl font-bold text-background-50">黄金</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200">
              权威黄金行情与投资指导平台，专注黄金现货、期货价格及深度市场分析，助您科学把握投资机会。
            </p>
          </div>

          <div>
            <h3 className="mb-4 font-heading text-base font-semibold text-background-50">快速导航</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="transition-colors hover:text-primary-300">首页</Link></li>
              <li><Link to="/category/gold-price" className="transition-colors hover:text-primary-300">黄金行情</Link></li>
              <li><Link to="/category/investment-news" className="transition-colors hover:text-primary-300">投资资讯</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-primary-300">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-heading text-base font-semibold text-background-50">热门专题</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/category/investment-news" className="transition-colors hover:text-primary-300">黄金投资入门</Link></li>
              <li><Link to="/category/gold-price" className="transition-colors hover:text-primary-300">市场回顾</Link></li>
              <li><Link to="/category/investment-news" className="transition-colors hover:text-primary-300">央行购金观察</Link></li>
              <li><Link to="/search?q=美联储" className="transition-colors hover:text-primary-300">美联储动态</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-heading text-base font-semibold text-background-50">联系我们</h3>
            <ul className="space-y-2.5 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" aria-hidden="true"></i>
                service@gold.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line" aria-hidden="true"></i>
                工作日 09:00 - 18:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line" aria-hidden="true"></i>
                上海市浦东新区陆家嘴环路
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-secondary-700 pt-6">
          <p className="text-xs leading-relaxed text-secondary-300">
            <strong className="font-semibold text-secondary-200">免责声明：</strong>
            本站所提供的黄金行情数据、价格走势及分析内容均为演示样例，不构成任何投资建议。市场有风险，投资需谨慎。请以官方权威渠道发布的实时数据为准。
          </p>
          <div className="mt-5 flex flex-col items-start justify-between gap-3 border-t border-secondary-800 pt-5 text-xs text-secondary-300 sm:flex-row sm:items-center">
            <span>© 2026 黄金 GOLD · 保留所有权利</span>
            <span className="flex flex-wrap items-center gap-x-4 gap-y-1">
              <span>本站数据仅供参考，据此操作风险自担</span>
              <span className="hidden sm:inline">·</span>
              <span>沪ICP备00000000号（演示）</span>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}